<template>
  <div
    :id="download ? 'download-resume' : ''"
    :class="[
      'resume-main',
      className,
      isPage ? 'is-page' : '',
      (cvDetail.basic_info && cvDetail.basic_info.lang) || '',
      cvPageSize,
    ]"
    ref="resumeMain"
    :style="mode === 'image' ? {} : {
      height: `calc(${297 * page.length * scale}mm + ${10 * (page.length - 1) * scale}mm + 0mm)`,
    }"
  >
    <!-- 骨架图 -->
    <transition name="opacity">
      <skeleton :type="2" v-if="!visible" />
    </transition>

    <!-- 简历预览区域 -->
    <div
      :class="['scale', visible ? 'visible' : '']"
      :style="{ transform: `scale(${scale})` }"
      :id="idName"
    >
      <div
        :ref="idName"
        id="cv-container"
        class="is-page-margin"
        :style="{
          marginTop: `-${
            isPage ? (pageIndex - 1) * ((cvPageSize === 'letter_size' ? 279.4 : 297) + 10) : 0
          }mm`,
        }"
      >
        <template>
          <div
            ref="pageMain"
            v-for="(p, j) in page"
            :key="j"
            :data-resume-page="j + 1"
            :style="{
              fontFamily: `${fontFamily(
                userFontFamily,
                cvDetail.basic_info.lang,
                cvDetail.format_info.font,
              )}`,
              'line-height': `${lineHeight}px`,
            }"
            :class="[
              'main',
              `main-${cvDetail.format_info.watermark}`,
              'one-page-container',
              `page-index-${j + 1}`,
              `padding-${cvDetail.format_info.page_margin}`,
              `lineH-${Math.ceil(lineHeight)}`,
              `fontsize-${cvDetail.format_info.font_size}`,
              `${cvDetail.format_info.top_format}-header`,
              mode,
            ]"
          >
            <div
              v-if="displayBlockHeaderLine(j)"
              class="header-line"
              :style="{ backgroundColor: cvDetail.format_info.top_line_color }"
            ></div>

            <!-- 简历花纹 -->
            <img
              v-if="cvDetail.format_info.pattern"
              class="cv-pattern"
              :src="cvDetail.format_info.pattern"
              :style="
                cvDetail.format_info.pattern_position === 'left'
                  ? { transform: 'rotateY(180deg)' }
                  : {}
              "
            />

            <div :class="['main-page-' + j]" class="content" ref="content" :data-page="j">
              <div
                ref="contentScroll"
                class="content-scroll"
                :style="{ 'margin-top': p.scroll + 'px' }"
                :data-page="j"
              >
                <!-- 内容start -->
                <!-- 用户模块基本信息 -->
                <div
                  v-if="cvDetail.format_info && cvDetail.format_info.top_format !== 'left_block'"
                  :class="[
                    'user',
                    'avatar',
                    `show-attr-name-${profile.show_attr_name}`,
                    `section-margin-${cvDetail.format_info.page_margin}`,
                    cvDetail.basic_info.school_logo_url ? 'school-logo' : '',
                    cvDetail.format_info.head_format,
                  ]"
                  :style="{ color: cvDetail.format_info.profile_color }"
                >
                  <div class="user-info has-profile">
                    <div v-if="profile.username" class="user-name">
                      {{ profile.username }}
                    </div>

                    <div class="profile-item" v-if="hasProfile">
                      <span v-if="profile.phone && profile.phone !== '电话'">
                        <i class="attr-icon iconfont icondianhua2"></i>
                        <label class="attr-name">
                          {{ cvDetail.basic_info.lang === 'cn' ? '电话' : 'Phone' }}： </label
                        >{{ profile.phone }}
                      </span>
                      <span v-if="profile.email && profile.email !== '邮箱'">
                        <i class="attr-icon iconfont iconyouxiang2"></i>
                        <label class="attr-name">
                          {{ cvDetail.basic_info.lang === 'cn' ? '邮箱' : 'Email' }}： </label
                        >{{ profile.email }}
                      </span>
                      <span v-if="profile.address">
                        <i class="attr-icon iconfont iconxianjuchengshi"></i>
                        <label class="attr-name">
                          {{ cvDetail.basic_info.lang === 'cn' ? '现居城市' : 'Address' }}： </label
                        >{{ profile.address }}
                      </span>
                    </div>
                    <div class="profile-item">
                      <span v-if="profile.wechat">
                        <i class="attr-icon iconfont iconweixin2"></i>
                        <label class="attr-name">
                          {{ cvDetail.basic_info.lang === 'cn' ? '微信' : 'WeChat' }}： </label
                        >{{ profile.wechat }}
                      </span>
                      <span v-if="profile.linked_in">
                        <i class="attr-icon iconfont iconlingying"></i>
                        <label class="attr-name">
                          {{ cvDetail.basic_info.lang === 'cn' ? '领英' : 'LinkedIn' }}： </label
                        >{{ profile.linked_in }}
                      </span>
                      <span v-if="profile.homepage">
                        <i class="attr-icon iconfont icongerenwangzhan"></i>
                        <label class="attr-name">
                          {{ cvDetail.basic_info.lang === 'cn' ? '个人网站' : 'Website' }}： </label
                        >{{ profile.homepage }}
                      </span>
                    </div>

                    <div class="profile-item">
                      <!-- 年龄生日后续修改 -->
                      <span v-if="profile.birthday">
                        <i class="attr-icon iconfont iconnianling"></i>
                        <label class="attr-name">
                          {{
                            cvDetail.basic_info.lang === 'cn'
                              ? ageBirthday === 'age'
                                ? '年龄'
                                : '生日'
                              : ageBirthday === 'age'
                              ? 'Age'
                              : 'Birthdate'
                          }}： </label
                        >{{ birthdayTypeValue }}
                      </span>
                      <span v-if="profile.gender">
                        <i class="attr-icon iconfont iconxingbie"></i>
                        <label class="attr-name">
                          {{ cvDetail.basic_info.lang === 'cn' ? '性别' : 'Gender' }}： </label
                        >{{ profile.gender }}
                      </span>
                      <span v-if="profile.height">
                        <i class="attr-icon iconfont iconshengao"></i>
                        <label class="attr-name">
                          {{ cvDetail.basic_info.lang === 'cn' ? '身高' : 'Height' }}： </label
                        >{{ profile.height }}
                      </span>
                      <span v-if="profile.weight">
                        <i class="attr-icon iconfont icontizhong"></i>
                        <label class="attr-name">
                          {{ cvDetail.basic_info.lang === 'cn' ? '体重' : 'Weigth' }}： </label
                        >{{ profile.weight }}
                      </span>
                      <span v-if="profile.hometown">
                        <i class="attr-icon iconfont iconjiguan"></i>
                        <label class="attr-name">
                          {{ cvDetail.basic_info.lang === 'cn' ? '籍贯' : 'Hometown' }}： </label
                        >{{ profile.hometown }}
                      </span>
                      <span v-if="profile.ethnic">
                        <i class="attr-icon iconfont iconminzu"></i>
                        <label class="attr-name">
                          {{ cvDetail.basic_info.lang === 'cn' ? '民族' : 'Ethnic' }}： </label
                        >{{ profile.ethnic }}
                      </span>
                      <span v-if="profile.political_status">
                        <i class="attr-icon iconfont iconzhengzhimianmao"></i>
                        <label class="attr-name">
                          {{
                            cvDetail.basic_info.lang === 'cn' ? '政治面貌' : 'Political Status'
                          }}： </label
                        >{{ profile.political_status }}
                      </span>
                      <span v-if="profile.marriage">
                        <i class="attr-icon iconfont iconhunyinzhuangkuang"></i>
                        <label class="attr-name">
                          {{
                            cvDetail.basic_info.lang === 'cn' ? '婚姻状况' : 'Marriage Status'
                          }}： </label
                        >{{ profile.marriage }}
                      </span>
                    </div>

                    <div class="profile-item">
                      <span v-if="profile.current_job">
                        <i class="attr-icon iconfont icondangqiangongzuozhuangtai"></i
                        ><label class="attr-name"
                          >{{
                            cvDetail.basic_info.lang === 'cn' ? '当前状态' : 'Current Status'
                          }}： </label
                        >{{ profile.current_job }}
                      </span>
                      <span v-if="profile.exp_city">
                        <i class="attr-icon iconfont iconxianjuchengshi"></i
                        ><label class="attr-name"
                          >{{
                            cvDetail.basic_info.lang === 'cn' ? '意向城市' : 'Expected City'
                          }}：</label
                        >{{ profile.exp_city }}
                      </span>
                      <!-- 求职意向后续修改 -->
                      <span v-if="profile.exp_job">
                        <i class="attr-icon iconfont iconqiuzhiyixiang"></i
                        ><label class="attr-name"
                          >{{
                            cvDetail.basic_info.lang === 'cn' ? '求职意向' : 'Objective'
                          }}：</label
                        >{{ profile.exp_job }}
                      </span>
                      <span v-if="profile.expected_salary">
                        <i class="attr-icon iconfont iconqiwangxinzi"></i
                        ><label class="attr-name"
                          >{{
                            cvDetail.basic_info.lang === 'cn' ? '期望薪资' : 'Expected Salary'
                          }}：</label
                        >{{ profile.expected_salary }}
                      </span>
                    </div>
                  </div>

                  <div class="user-avatar">
                    <!-- 整体居中 头像 兼容pdf -->
                    <template v-if="cvDetail.format_info.head_format === 'body_center'">
                      <div
                        class="user-avatar-image"
                        v-if="profile.avatar_url"
                        :style="{
                          backgroundImage: `url(${profile.avatar_url}`,
                        }"
                      ></div>
                    </template>
                    <template v-else>
                      <img
                        class="user-avatar-image"
                        v-if="profile.avatar_url"
                        :src="profile.avatar_url"
                        alt=""
                      />
                    </template>
                  </div>

                  <div v-if="cvDetail.basic_info.school_logo_url" class="user-school">
                    <img :src="cvDetail.basic_info.school_logo_url" />
                  </div>
                  <!-- 商务简历模版个人信息背景色块 block -->
                  <div
                    v-if="cvDetail.format_info.top_format === 'block'"
                    class="user-background"
                    :style="{
                      'background-color': cvDetail.format_info.top_line_color,
                    }"
                  ></div>
                  <!-- 沉稳简历模版个人信息顶部圆弧色块 circle -->
                  <div
                    v-else-if="cvDetail.format_info.top_format === 'circle'"
                    class="user-background circle-wrapper"
                  >
                    <div
                      class="circle-content"
                      :style="{
                        'background-color': cvDetail.format_info.top_line_color,
                      }"
                    ></div>
                  </div>
                </div>
                <!-- 简约简历模版左侧个人信息 left_block -->
                <div v-else class="left-profile-wrapper">
                  <div
                    class="profile-content"
                    :style="{
                      'background-color': cvDetail.format_info.top_line_color,
                      color: cvDetail.format_info.profile_color,
                    }"
                  >
                    <template v-if="j === 0">
                      <div class="user-avatar-container">
                        <img
                          v-if="profile.avatar_url"
                          :src="profile.avatar_url"
                          alt=""
                          class="user-avatar"
                        />
                      </div>
                      <!-- 姓名 -->
                      <div v-if="profile.username" class="user-name">
                        {{ profile.username }}
                      </div>
                      <!-- 其他信息 -->
                      <div class="profile-other">
                        <template v-for="(item, index) in otherModuleKeys">
                          <div v-if="profile[item]" :key="index" class="other-item">
                            {{ profile[item] }}
                          </div>
                        </template>
                        <div v-if="profile.birthday" class="other-item">
                          {{ birthdayTypeValue }}
                        </div>
                      </div>
                      <!-- 联系方式 -->
                      <div v-if="checkModuleEmpty(contactModule.list)" class="profile-module">
                        <div class="profile-module-title">
                          {{ contactModule.title }}
                        </div>
                        <template v-for="(item, index) in contactModule.list">
                          <div v-if="profile[item.key]" :key="index" class="info-item flex">
                            <span class="flex-shrink-0">{{
                              item[cvDetail.basic_info.lang] || item.title
                            }}</span>
                            <span>{{ profile[item.key] }}</span>
                          </div>
                        </template>
                      </div>
                      <!-- 求职意向 -->
                      <div v-if="checkModuleEmpty(intentionModule.list)" class="profile-module">
                        <div class="profile-module-title">
                          {{ intentionModule.title }}
                        </div>
                        <template v-for="(item, index) in intentionModule.list">
                          <div v-if="profile[item.key]" :key="index" class="info-item flex">
                            <span class="flex-shrink-0">{{
                              item[cvDetail.basic_info.lang] || item.title
                            }}</span>
                            <span>{{ profile[item.key] }}</span>
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="section-wrapper">
                  <!-- 大模块 -->
                  <template v-for="(opt, num) in sectionPosition">
                    <!-- 模块有内容时 -->
                    <div
                      v-if="
                        (opt.type === 'extras' && extrasNotEmpty()) ||
                        (getInfosByType(opt) && getInfosByType(opt).length)
                      "
                      :id="[opt.type === 'custom' ? `custom-${opt.id}` : opt.type]"
                      :key="num"
                      :class="[
                        opt.type === 'custom' ? `custom-${opt.id}` : opt.type,
                        cvDetail.format_info.top_format === 'left_form'
                          ? `section-margin-${cvDetail.format_info.page_margin} left-form-option`
                          : '',
                      ]"
                      class="option pr"
                    >
                      <div
                        :class="[
                          'module-title-wrapper',
                          cvDetail.format_info.top_format !== 'left_form'
                            ? `section-margin-${cvDetail.format_info.page_margin}`
                            : '',
                        ]"
                        :style="
                          cvDetail.format_info.top_format === 'left_form'
                            ? {
                                paddingRight: '8px',
                                marginRight: '16px',
                                borderRight: `2px solid ${cvDetail.format_info.title_color}`,
                              }
                            : {}
                        "
                      >
                        <module-title
                          :item="opt"
                          :index="num"
                          :sPosition="sectionPosition"
                          :titleType="cvDetail.format_info.title_format"
                          :titleName="getSectionTitle(opt) || currentInfo.title"
                          :titleTheme="cvDetail.format_info.title_color"
                          :moduleType="opt.type"
                          :width="maxTitleWidth"
                        />
                      </div>
                      <div class="info-content" style="flex: 1">
                        <ul
                          class="menu extras pr"
                          v-if="opt.type === 'extras' && extrasNotEmpty()"
                          :class="[
                            cvDetail.format_info.top_format !== 'left_form'
                              ? `section-margin-${cvDetail.format_info.page_margin}`
                              : '',
                          ]"
                        >
                          <template v-for="(item, num) in extrasPosition">
                            <li
                              class="module-item extras-item pr"
                              :key="num"
                              v-if="extras[item] && extras[item].description"
                            >
                              <span class="font_w_b">{{
                                cvDetail.submodule_info[`${item}_title`]
                              }}</span>
                              <span>{{ extras[item] && extras[item].description }}</span>
                            </li>
                          </template>
                        </ul>
                        <!-- 作品集 -->
                        <template v-else-if="opt.type === 'opus' && getInfosByType(opt)">
                          <div
                            class="menu pr section-item-container opus-container"
                            :class="[
                              cvDetail.format_info.top_format !== 'left_form'
                                ? `section-margin-${cvDetail.format_info.page_margin}`
                                : '',
                            ]"
                          >
                            <template>
                              <div
                                class="opu-item"
                                v-for="(item, index) in getInfosByType(opt)"
                                :key="index"
                              >
                                <img :src="item.qrcode" class="qrcode-img" v-if="item.qrcode" />
                                <div class="qrcode iconfont iconplus" v-else></div>
                                <div class="desc" v-if="!item.url">
                                  {{ item.title }}
                                </div>
                                <div
                                  class="desc link"
                                  v-else
                                  @click.stop="openOpuItemLink(item.url)"
                                >
                                  <span>{{
                                    item.title ||
                                    `${
                                      cvDetail.basic_info.lang === 'cn'
                                        ? '作品链接'
                                        : 'portfolio link'
                                    }`
                                  }}</span>
                                </div>
                              </div>
                            </template>
                          </div>
                        </template>
                        <template v-else>
                          <template>
                            <div
                              v-for="(item, index) in getInfosByType(opt)"
                              class="menu pr section-item-container"
                              :key="index"
                              :class="[
                                `section-${item.id}`,
                                cvDetail.format_info.top_format !== 'left_form'
                                  ? `section-margin-${cvDetail.format_info.page_margin}`
                                  : '',
                              ]"
                              :id="[`${opt.type === 'custom' ? `custom` : opt.type}-${item.id}`]"
                            >
                              <template
                                v-if="opt.type !== 'personal_summary' && opt.type !== 'skill_list'"
                              >
                                <!-- 一级标题 -->
                                <div
                                  v-if="showMenuTitle(item, index, getInfosByType(opt))"
                                  class="menu-title"
                                  :class="{'edus-menu-title-container': opt.type === 'edus' && item.show_tags && item.show_tags.length}"
                                >
                                  <div class="left flex1" :class="{ 'edu-left-content': opt.type === 'edus' && item.show_tags && item.show_tags.length }">
                                    <span
                                      :class="{
                                        font_w_b: opt.type !== 'honor',
                                      }"
                                      style="word-break: break-all"
                                    >
                                      {{ item.company || item.university || item.name }}
                                    </span>
                                    <template
                                      v-if="
                                        item.university &&
                                        item.show_tags &&
                                        item.show_tags.length &&
                                        cvDetail.format_info.body_format === 'two_line'
                                      "
                                    >
                                      <!--                                  {{ JSON.stringify(item) }}-->
                                      <div
                                        class="school-tag-item"
                                        v-for="itemD in item.show_tags"
                                        :key="itemD"
                                      >
                                        {{ itemD }}
                                      </div>
                                    </template>
                                    <!-- <span>==</span> -->
                                    <span
                                      v-if="
                                        cvDetail.format_info.punctuation_format ===
                                          'show_punctuation' &&
                                        cvDetail.format_info.body_format === 'one_line' &&
                                        (item.company || item.university || item.name) &&
                                        (item.major ||
                                          item.uni_school ||
                                          item.title ||
                                          item.dept ||
                                          item.degree)
                                      "
                                    >
                                      -
                                    </span>
                                    <template
                                      v-if="cvDetail.format_info.body_format === 'one_line'"
                                    >
                                      {{ item.major }}
                                      {{ item.degree_id | degree(myself, item.degree) }}
                                      {{ item.uni_school }}
                                      {{ item.title }} {{ item.dept }}
                                    </template>
                                  </div>
                                  <div
                                    class="right"
                                    v-if="
                                      cvDetail.format_info.format_priority !== 'city' ||
                                      cvDetail.format_info.body_format === 'one_line'
                                    "
                                  >
                                    <span v-if="item.start_at">{{
                                      moment(item.start_at).format('YYYY.MM') | date(cvDetail)
                                    }}</span>
                                    <span v-if="item.start_at && (item.end_at || item.present)">
                                      -
                                    </span>
                                    <span v-if="item.end_at">{{
                                      moment(item.end_at).format('YYYY.MM') | date(cvDetail)
                                    }}</span>
                                    <span v-if="item.present">{{ item.present }}</span>
                                  </div>
                                  <div class="right" v-else>
                                    {{ item.city }}
                                  </div>
                                </div>
                                <!-- 子标题 -->
                                <div
                                  class="menu-title"
                                  v-if="
                                    showMenuSTitle(item) &&
                                    cvDetail.format_info.body_format !== 'one_line'
                                  "
                                >
                                  <div class="left flex1">
                                    {{ item.major }}
                                    {{ item.degree_id | degree(myself, item.degree) }}
                                    {{ item.uni_school }}
                                    {{ item.title }} {{ item.dept }}
                                  </div>
                                  <div
                                    class="right"
                                    v-if="cvDetail.format_info.format_priority === 'city'"
                                  >
                                    <span v-if="item.start_at">
                                      {{ moment(item.start_at).format('YYYY.MM') | date(cvDetail) }}
                                    </span>
                                    <span v-if="item.start_at && (item.end_at || item.present)">
                                      -
                                    </span>
                                    <span
                                      v-if="
                                        item.present !== '至今' &&
                                        item.present !== 'Present' &&
                                        item.end_at
                                      "
                                    >
                                      {{ moment(item.end_at).format('YYYY.MM') | date(cvDetail) }}
                                    </span>
                                    <span v-if="item.present">{{ item.present }}</span>
                                  </div>
                                  <div class="right" v-else>
                                    {{ item.city }}
                                  </div>
                                </div>
                              </template>
                              <div class="menu-content-wrapper pr">
                                <div
                                  class="school-tag-container online-tag"
                                  v-if="
                                    item.university &&
                                    item.show_tags &&
                                    item.show_tags.length &&
                                    cvDetail.format_info.body_format === 'one_line'
                                  "
                                >
                                  <div
                                    class="school-tag-item"
                                    v-for="itemD in item.show_tags"
                                    :key="itemD"
                                  >
                                    {{ itemD }}
                                  </div>
                                </div>
                                <div class="menu-content" v-html="item.description"></div>
                              </div>
                            </div>
                          </template>
                          <!-- 子模块 -->
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
                <!-- 内容end -->
              </div>
            </div>
            <div class="cover cover-transparent" :style="{ height: p.height + 'px' }">
              <div
                v-if="cvDetail.format_info.top_format === 'left_block'"
                class="left-profile-bottom"
                :style="{
                  'background-color': cvDetail.format_info.top_line_color,
                }"
              ></div>
            </div>
            <div class="cover" :style="{ height: p.height + 'px' }"></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { random, get_tUser } from '@/assets/js/util';
import skeleton from '@/components/cvs/editor/img';
import moment from 'moment';
import degree from '@/assets/json/degree';
import { dealCvDataMixin, cvMixin } from '@/assets/js/mixins';
import moduleTitle from '../moduleTitle';
import { contactModule, intentionModule, otherModuleKeys } from '@/assets/json/editor-profile';
let elementResizeDetectorMaker = require('element-resize-detector');
const erd = elementResizeDetectorMaker();

function getTop(e) {
  var offset = e.offsetTop;
  if (e.offsetParent != null) offset += getTop(e.offsetParent);
  return offset;
}

let page = [{ scroll: 0 }];
let resumeRun = false;

export default {
  name: 'resume',
  mixins: [dealCvDataMixin, cvMixin],
  components: {
    skeleton,
    moduleTitle,
  },
  props: {
    autoPage: {
      type: Boolean,
      default: false,
    },
    // 是否分页
    isPage: {
      type: false,
      required: false,
    },
    // 当前页码
    pageIndex: {
      type: Number,
      required: false,
      default: 1,
    },
    // 是否缩放
    isScale: {
      type: Boolean,
      default: true,
    },
    // 是否可以下载简历
    download: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'preview',
    },
    needSetOnePage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      moment,
      className: 'resume-component-class-name-' + random(100000, 999999),
      idName: 'pdf' + random(1000, 9999), // id name
      scale: 1,
      visible: false,
      page,
      lineHeight: 12,
      cvHeight: 0, // 简历总高
      pageHeight: 0, // 容器高度
      pageMainHeight: 0, // 容器高度，加上padding
      page_size: 'a4', // 纸张大小
      cvPageSize: 'a4', // cv纸张大小
      myself: this,
      currentPage: 1,
      reviseErrorStatus: false, //是否正在修复错误中
      contactModule,
      intentionModule,
      otherModuleKeys,
      maxTitleWidth: 0,
    };
  },
  computed: {
    ...mapState('cvsEditor', ['cvToken', 'list']),
    ...mapState('editor', [
      'profile',
      'cvDetail',
      'extras',
      'oldLineHeight',
      'autoOnePage',
      'resumeWidth',
      'currentInfo',
      'backUpProfile',
      'edus',
      'orgs',
      'works',
    ]),
    ...mapGetters('cvs', ['cvs', 'cv']),
    ...mapState('experience', ['userFontFamily']),
    // 是否有基本信息
    hasProfile() {
      let notCheckField = ['created_at', 'format_pref', 'show_attr_name', 'updated_at'];
      for (let k in this.profile) {
        if (!notCheckField.includes(k) && this.profile[k]) {
          return true;
        }
      }
    },
    // 当前是选择的年龄还是生日
    ageBirthday() {
      if (this.profile.format_pref && this.profile.format_pref.age_birthday) {
        return this.profile.format_pref.age_birthday.chosen;
      } else {
        return 'birthday';
      }
    },
    // 年龄或者生日的值
    birthdayTypeValue() {
      let { format_pref } = this.profile;
      let {
        basic_info: { lang },
      } = this.cvDetail;
      if (format_pref && format_pref.age_birthday && this.profile.birthday) {
        if (this.profile.birthday && this.profile.birthday.includes('**')) {
          return '***';
        }
        // if((this.profile.birthday.includes('**')) || (format_pref.age_birthday.includes('**'))){
        // 	return '***'
        // }
        return format_pref.age_birthday.chosen === 'birthday'
          ? this.profile.birthday.slice(0, 7)
          : `${moment().diff(this.profile.birthday, 'years')}${lang === 'cn' ? '岁' : ''}`;
      }
    },
    // 是否是导师
    isMentor() {
      return window.location.href.includes('mentor');
    },
  },
  watch: {
    cvPageSize() {
      setTimeout(() => {
        this.setPageView();
        this.$forceUpdate();
      }, 300);
    },
    maxTitleWidth(newVal) {
      if (newVal) {
        if (
          this.cvDetail.basic_info?.title_max_width !== newVal &&
          this.cvDetail.basic_info?.token
        ) {
          this.updateCvDetail({
            operation_type: 'update_basic_info',
            basic_info: {
              title_max_width: newVal,
            },
            skipCheck: true,
          });
        }
      }
    },
    cvDetail: {
      deep: true,
      immediate: true,
      handler(cvDetail) {
        setTimeout(() => {
          this.setPageView();
          this.$forceUpdate();
        }, 300);
        this.cvPageSize = (cvDetail.format_info && cvDetail.format_info.page_size) || 'a4';
        this.lineHeight = (cvDetail.format_info && cvDetail.format_info.line_spacing) || 18;
      },
    },
    // 提交page数量
    page: {
      deep: true,
      immediate: true,
      handler: function (page, oldVal) {
        if (this.mode === 'image') return;
        // this.$store.dispatch('cvs/setCvPages', page.length)
        this.$emit('get-pages', page.length);
        if (
          this.cvDetail.basic_info?.pdf_count !== page.length &&
          this.cvDetail.basic_info?.token &&
          page?.length !== oldVal?.length &&
          !['template', 'sample'].includes(this.cvDetail.basic_info?.kind) &&
          get_tUser()?.c_t
        ) {
          this.updateCvDetail({
            operation_type: 'update_basic_info',
            basic_info: {
              pdf_count: page.length,
            },
            skipCheck: true,
          });
        }
        if (page.length === 0) {
          this.page = page;
        }
      },
    },
  },
  filters: {
    date: function (value, cvDetail) {
      if (!value) {
        return '';
      }
      let { basic_info, format_info, submodule_info } = cvDetail;
      let type = format_info.time_format;
      let lang = basic_info.lang;
      let reg = /(\d{4}).*?(\d{1,2}).*?/gim;
      let str = '';
      if (lang === 'cn') {
        str = value.replace(reg, type === 'number' ? '$1.$2' : '$1年$2月');
      } else {
        let month = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
        let m = value.replace(reg, `$2`);
        let y = value.replace(reg, '$1');
        str = type === 'number' ? `${y}.${m}` : `${month[m - 1]} ${y}`;
      }

      return str;
    },
    age(d, type) {
      if (type !== 'age') {
        return d;
      }
      if (!d) {
        return '';
      }
      let time = Date.now() - new Date(d).getTime();
      return Math.ceil(time / 1000 / 60 / 60 / 24 / 365) + '岁';
    },
    degree(id, myself, degreeName) {
      let item = degree.filter((item) => item.id === id);
      let lang = myself.cvDetail.basic_info.lang;
      return item.length ? item[0][lang || 'cn'] : degreeName || '';
    },
  },
  async mounted() {
    this.setOnePageFunction(this.onePage);
    this.visible = false;
    await this.setPageView();
    this.changeEleResize();
  },
  methods: {
    ...mapActions('editor', ['updateCvDetail']),
    ...mapMutations('editor', ['setOnePageFunction', 'setAutoOnePage', 'setOldLineHeight']),
    checkModuleEmpty(list) {
      return list.some((item) => this.profile[item.key]);
    },
    displayBlockHeaderLine(i) {
      const { top_format } = this.cvDetail.format_info || {};
      return (
        ['line', 'left_block'].includes(top_format) ||
        (['block', 'circle'].includes(top_format) && i === 0)
      );
    },
    //打开作品集写的url
    openOpuItemLink(url) {
      window.open(url.includes('//') ? url : `//${url}`);
    },
    // 监听填写内容是超过当前总页数时dom的高度
    changeEleResize() {
      erd.listenTo(document.querySelectorAll('.content-scroll')[0], (el) => {
        this.$nextTick(() => {
          const onePageEl = document.querySelector('.content');
          let page = Math.ceil(el.clientHeight / onePageEl.clientHeight);
          if (page !== this.page.length) {
            setTimeout(() => {
              this.setPageView();
              this.$forceUpdate();
            }, 30);
          }
        });
      });
    },
    // 计算缩放比例
    countScale() {
      this.$nextTick(async () => {
        setTimeout(() => {
          window.resumeMain = this.$refs.resumeMain;
          let pageMain = this.$refs.pageMain[0] ? this.$refs.pageMain[0].offsetWidth : 720;
          this.isScale && (this.scale = this.resumeWidth / pageMain);
          setTimeout(() => {
            this.visible = true;
          }, 500);
          this.$emit('nextTick');
        }, 100);
      });
    },
    setPageInfo() {
      let contentHeight = this.$refs.content[0].offsetHeight;
      let contentScrollHeight = this.$refs.contentScroll[0].offsetHeight;
      let pageMainHeight = this.$refs.pageMain[0].offsetHeight;
      this.cvHeight = contentScrollHeight; // 简历总高度
      this.pageHeight = contentHeight; // 页码容器高度
      this.pageMainHeight = pageMainHeight;
    },
    // 一页纸
    async onePage(isClick) {
      let { kind } = this.cvDetail.basic_info;
      clearTimeout(resumeRun);
      resumeRun = setTimeout(async () => {
        if (this.autoOnePage) {
          this.cvDetailChange(this.oldLineHeight, !this.autoOnePage);
          this.setAutoOnePage(!this.autoOnePage);
          this.$message.success('已取消一页纸');
          return false;
        }
        // start count
        const maxLineHeight = 28;
        const fontSize = this.cvDetail.format_info.font_size;
        const lineHeight = this.cvDetail.format_info.line_spacing;
        // 设置存放一页纸原来数据
        if (!isClick) this.setOldLineHeight(lineHeight);
        // start set line height
        let isTrue = false; // 是否可以实现一页纸
        let newLineHeight = lineHeight; // 一页纸之后的行距
        if (this.cvHeight < this.pageHeight / 2 - 160 && isClick) {
          this.$message.error('内容过少，无法调整到一页纸');
          return false;
        } else if (this.cvHeight > this.pageHeight * 2 + 160 && isClick) {
          this.$message.error('内容过多，无法调整到一页纸');
          return false;
        }
        if (this.cvHeight < this.pageHeight) {
          for (let i = lineHeight; i <= maxLineHeight; i++) {
            this.lineHeight = i;
            await this.$nextTick();
            await this.setPageInfo();
            let isOne = await this.isOnePage();
            if (isOne) {
              newLineHeight = i;
              isTrue = true;
            }
          }
        } else {
          for (let i = lineHeight - 1; i >= fontSize; i--) {
            this.lineHeight = i;
            await this.$nextTick();
            await this.setPageInfo();
            let isOne = await this.isOnePage();
            if (isOne) {
              newLineHeight = i;
              isTrue = true;
              break;
            }
          }
        }
        this.lineHeight = newLineHeight;
        // 结束一页纸逻辑，进行展示
        if (isTrue) {
          this.cvDetailChange(newLineHeight, !this.autoOnePage);
          if (isClick) this.setAutoOnePage(!this.autoOnePage);
          if (!isClick && (kind === 'template' || kind === 'sample')) {
            return false;
          }
          this.$message.success('已调整为一页纸');
        } else {
          if (isClick) {
            this.$message.error('内容过多无法一页纸，请删减内容或调整字号');
          }
        }
      }, 300);
    },
    // 更新简历详情的数据
    async cvDetailChange(lineHeight, isPage) {
      let { format_info } = this.cvDetail;
      format_info = {
        ...format_info,
        line_spacing: lineHeight,
        is_one_page: isPage,
      };
      return await this.updateCvDetail({
        not_need_default_error_tips: true,
        operation_type: 'update_format_info',
        format_info,
        skipCheck: true,
      });
    },
    // 是否已经一页纸
    isOnePage() {
      let isTrue = this.cvHeight < this.pageHeight;
      if (isTrue) {
        this.page = [
          {
            ...this.page[0],
            height: 0,
          },
        ];
      }
      return isTrue;
    },
    // 计算title的最大宽度
    calcMaxTitleWidth() {
      this.$nextTick(() => {
        const els = document.querySelectorAll('.default-title-wrapper .title');
        if (els?.length && this.cvDetail?.format_info?.top_format === 'left_form') {
          let width = 0;
          els.forEach((item) => {
            width = Math.min(Math.max(width, item.offsetWidth), 112);
          });
          this.maxTitleWidth = width;
        } else {
          this.maxTitleWidth = 0;
        }
      });
    },
    // 计算高度 缩放比例
    setPageView() {
      const body = document.body;
      if (!this.page.length) {
        this.page = page;
      }
      if (this.mode === 'image') {
        this.page = page;
        return;
      }
      // 高度计算(页面计算，偏移量计算)
      this.$nextTick(async () => {
        if (!this.$refs.content) {
          return false;
        }
        if (!this.$refs.contentScroll[0] || !this.$refs.content[0]) {
          return false;
        }
        let contentHeight = this.$refs.content[0].offsetHeight;
        let contentScrollHeight = this.$refs.contentScroll[0].offsetHeight;
        let page = [];
        let length = Math.ceil(contentScrollHeight / contentHeight) || 1;
        for (let i = 0; i < length; i++) {
          page[i] = {
            scroll: -contentHeight * i,
            height: 0,
          };
        }
        this.page = page;
        this.setPageInfo();
        // 遮挡计算
        this.$nextTick(async () => {
          // for (let i = 0; i < this.page.length; i++) {
          //   await this.$nextTick(() => {
          //     // 当前页码内所有dom
          //     let domTitle = document.querySelectorAll(
          //       `.${this.className}.resume-main .main-page-${i} .title`,
          //     );
          //     let domClass = document.querySelectorAll(
          //       `.${this.className}.resume-main .main-page-${i} .menu-title`,
          //     );
          //     let domName = document.querySelectorAll(
          //       `.${this.className}.resume-main .main-page-${i} .name`,
          //     );
          //     let domOl = document.querySelectorAll(
          //       `.${this.className}.resume-main .main-page-${i} ol`,
          //     );
          //     let domLi = document.querySelectorAll(
          //       `.${this.className}.resume-main .main-page-${i} li`,
          //     );
          //     let domP = document.querySelectorAll(
          //       `.${this.className}.resume-main .main-page-${i} p`,
          //     );
          //     let dom = [...domTitle, ...domClass, ...domName, ...domOl, ...domLi, ...domP];
          //     // 当前页码容器dom
          //     let parent = document.querySelector(`.${this.className}.resume-main .main-page-${i}`);
          //     let contentHeight = parent.offsetHeight;

          //     let parentTop = getTop(parent);
          //     for (let j = 0; j < dom.length; j++) {
          //       let top = getTop(dom[j]); // 当前节点到top的距离
          //       let height = dom[j].offsetHeight; // 当前节点的高度
          //       // 当前节点是否处于两页中间（半行字）
          //       let isTrue =
          //         parentTop + contentHeight > top && parentTop + contentHeight < top + height;
          //       if (isTrue) {
          //         let x = Math.abs(parentTop + contentHeight - top);
          //         let lineHeight = this.cvDetail.format_info.line_spacing - 0; // 行高
          //         let h = (x % lineHeight) + 4;
          //         let page = this.page;
          //         page[i].height = h;
          //         // 修改page页码布局数据(元素偏移量)
          //         for (let k = 1; k < page.length; k++) {
          //           page[k].scroll = -Math.abs(
          //             Math.abs(page[k - 1].scroll) + contentHeight - page[k - 1].height,
          //           );
          //         }
          //         this.page = page;
          //       }
          //     }
          //   });
          // }
          this.countScale();
          this.calcMaxTitleWidth();
        });
      });
    },
    //是否显示标题
    showMenuTitle(item, index, expArr) {
      let { format_info } = this.cvDetail;
      // 此经历不是第一段经历 && 是子经历 && 公司名和上一段经历公司名相同 ====> 不显示主标题
      if (index > 0 && item.is_sub_item && item.company === expArr[index - 1].company) {
        return false;
      }
      return (
        item.company ||
        item.university ||
        item.name ||
        (format_info.body_format === 'one_line' &&
          (item.major || item.degree_id || item.uni_school || item.title || item.dept)) ||
        (format_info.format_priority !== 'city' &&
          (item.start_at || item.end_at || item.present)) ||
        item.city
      );
    },
    //是否显示小标题
    showMenuSTitle(item) {
      let { format_info } = this.cvDetail;
      return (
        item.major ||
        item.degree_id ||
        item.uni_school ||
        item.title ||
        item.dept ||
        (format_info.format_priority === 'city' && (item.start_at || item.end_at)) ||
        (format_info.format_priority !== 'city' && item.city)
      );
    },
    fontFamily(userFontFamily, lang, fontId) {
      let list = userFontFamily[lang];
      let defaultFontFamily = lang === 'cn' ? 'PingFang SC, Microsoft YaHei' : 'Arial';
      const item = list?.find((item) => item.id === fontId && item.hasFont);
      return item ? `${item.name.join(',')}` : defaultFontFamily;
    },
  },
  beforeDestroy() {
    erd.removeAllListeners();
  },
};
</script>
<style lang="scss" scoped>
@import './newResume.scss';
.scale {
  position: relative;
  .cv-font-number {
    position: absolute;
    top: 11px;
    right: 13px;
    z-index: 3;
    font-size: 12px;
    color: #9c9c9c;
    .hint {
      position: absolute;
      text-align: center;
      line-height: 50px;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      width: 258px;
      height: 50px;
      background: #353944;
      box-shadow: 0px 2px 12px 0px rgba(128, 128, 128, 0.12);
      right: 0;
      top: 25px;
      border-radius: 6px;
      &::after {
        content: '';
        border: 6px solid #353944;
        position: absolute;
        border-top-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
        bottom: 49px;
        right: 20px;
      }
    }
  }
}
</style>
<style lang="scss">
.resume-main {
  position: relative;
}
.main {
  ul,
  ol {
    padding-left: 20px;
  }
  ul li {
    list-style: disc;
  }
  ol li {
    list-style: decimal;
  }
}
.cover-transparent {
  z-index: 4 !important;
  background-color: transparent !important;
}
</style>
